/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

const fetchOrderDetailsAPI = (jwt, payload, headers, backUpEmail, page) => {
    const wcEnv = {
        rootUri: '/',
    };
    const { email } = payload;
    const newPayload = { ...payload };
    if (!email) {
        newPayload.email = backUpEmail;
    }
    const resourcePath = `retention/selfservice/order/v2/status?page=${page || 1}`;
    return restClient.postFacade(wcEnv, resourcePath, jwt, newPayload, null, headers, false).then((response) => response);
};

export default fetchOrderDetailsAPI;
